import React, { Component } from 'react';
import {titleTemplate} from 'utils/seoUtils';
import {SportHomePageContent} from "../../Common/pages/SportHomePageContent";

export default class HorseRacingHomePage extends Component {
  render() {
    const { location } = this.props;

    return <SportHomePageContent
      sport="racing"
      title="Horse Racing Betting Tips | Racecards & Resultss"
      location={ location }
      helmetProps={ {titleTemplate: titleTemplate.plain} }
      rightColumnContent={
        ["mostReadRacing", "topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget"]
      }
    />
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingHomePage.js